// Libraries
import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

// Local libraries
import phrasebookLoad from "../../i18n";

// Redux
import { accountActions } from 'actions';

// Components
import RegularButton from "../../components/Buttons/RegularButton";

const phrasebook = phrasebookLoad()

class Login extends React.Component {
  constructor(props) {
    super(props);

    // reset login status
    this.props.dispatch(accountActions.logout());

    this.state = {
      email: '',
      password: '',
      submitted: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { email, password } = this.state;
    // const { dispatch } = this.props;
    if (email && password) {
      this.props.dispatch(accountActions.login(email, password));
    }
  }

  render = () => <form name="login" className="d-flex flex-column flex-sm-row text-center text-white" onSubmit={this.handleSubmit}>
    <div className="flex-1 bg-light-blue-95 p-1 p-sm-2 p-md-3">
      <Link to="/account/Login" className="loop-img"></Link>
      <h3 className="mb-0">{phrasebook.login_view.intro}</h3>
      <p className="d-none d-sm-block text-justify mt-1">{phrasebook.login_view.description}</p>
    </div>

    <div className="flex-1 bg-dark-blue-95 p-1 p-sm-2 p-md-3">
      <div>
        <h3>{phrasebook.login_view.login}</h3>
        <p>{phrasebook.login_view.login_please}</p>
        <p />
        <div className="mb-1">
          <div className="form-col">
            <input type="text" id="email" placeholder="Email" name="email" onChange={this.handleChange} />
          </div>
          <div className="form-col">
            <input type="password" id="password" placeholder="Password" name="password" onChange={this.handleChange} />
          </div>
          {/* <input type="submit" id="login" className="btn btn-main btn-block" value="Login" /> */}
          <RegularButton type="submit" id="login" className="btn btn-main btn-block" />
        </div>
        <Link to="/account/forgot-password">{phrasebook.login_view.forgot_password}</Link><br></br>
        <Link to="/account/register">{phrasebook.login_view.register}</Link>
      </div>
    </div>
  </form>
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const login = connect(mapStateToProps)(Login);

export default (login);
